var map = {
	"./album1.jpg": "7b41",
	"./album2.jpg": "0dc8",
	"./album3.jpg": "a6a8",
	"./album4.jpg": "e49c",
	"./album5.jpg": "dec2",
	"./album6.jpg": "b34f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f0c";